define([], function() {

  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function arrayCopy(source, array) {
    var index = -1,
        length = source.length;

    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }

  return arrayCopy;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-amd/modern/internal/arrayCopy.js
// module id = 195
// module chunks = 0